export default __webpack_public_path__ + "static/p1b-76f1846cbccfa44483282166a179f9ab.png";